import { useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import { Check } from 'react-feather'

const NavigationBar = () => {
  const { numberStep } = useSelector((state) => state.comodityPurchase)
  
  const steps = [
    { num: 1, title: 'Tambah Barang' },
    { num: 2, title: 'Pembayaran' },
    { num: 3, title: 'Konfirmasi Pembelian' },
  ]

  return (
    <div className="mb-4">
      <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
        <CardBody className="p-4">
          <div className="d-flex flex-column flex-md-row justify-content-between position-relative">
            {steps.map((step, index) => {
              const isActive = numberStep === step.num
              const isPast = numberStep > step.num
              
              return (
                <div 
                  key={index}
                  className="d-flex align-items-center flex-md-column position-relative" 
                  style={{ flex: 1, gap: '16px', paddingBottom: index !== steps.length - 1 ? '24px' : '0' }}
                  data-testid={`transaction-step-${step.num}`}
                >
                  {/* Vertical Line for Mobile */}
                  {index !== steps.length - 1 && (
                    <div 
                      className="d-md-none position-absolute" 
                      style={{ 
                        left: '19px', 
                        top: '40px', 
                        bottom: '-10px', 
                        width: '2px', 
                        backgroundColor: isPast ? '#006386' : '#e2e8f0',
                        zIndex: 1
                      }}
                    />
                  )}
                  {/* Horizontal Line for Desktop */}
                  {index !== steps.length - 1 && (
                    <div 
                      className="d-none d-md-block position-absolute" 
                      style={{ 
                        top: '19px', 
                        left: 'calc(50% + 20px)', 
                        right: 'calc(-50% + 20px)', 
                        height: '2px', 
                        backgroundColor: isPast ? '#006386' : '#e2e8f0',
                        zIndex: 1
                      }}
                    />
                  )}
                  
                  <div 
                    className={`rounded-circle d-flex align-items-center justify-content-center fw-bold shadow-sm`}
                    style={{ 
                      width: '40px', 
                      height: '40px', 
                      minWidth: '40px',
                      backgroundColor: isActive || isPast ? '#006386' : '#f8fafc',
                      color: isActive || isPast ? 'white' : '#94a3b8',
                      border: `2px solid ${isActive || isPast ? '#006386' : '#e2e8f0'}`,
                      zIndex: 2,
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {isPast ? <Check size={20} strokeWidth={3} /> : step.num}
                  </div>
                  
                  <div 
                    className={`fw-semibold ${isActive ? 'text-dark' : isPast ? 'text-secondary' : 'text-muted'}`}
                    style={{ 
                      fontSize: '15px',
                      marginTop: 'auto',
                      marginBottom: 'auto'
                    }}
                  >
                    {step.title}
                  </div>
                </div>
              )
            })}
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

export default NavigationBar
